"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaAtestado = exports.yupAtestado = void 0;
const yup = __importStar(require("yup"));
const date_fns_1 = require("date-fns");
const utils_1 = require("../utils");
exports.yupAtestado = yup.object({
    dataIni: (0, utils_1.sge2Date)().required().default((0, date_fns_1.format)(new Date(), 'yyyy-MM-dd')).label('Data inicial'),
    dataFim: (0, utils_1.sge2Date)()
        .required()
        .test('match', 'A data inicial deve ser menor ou igual a final', (dataFim, { parent: { dataIni } }) => (0, date_fns_1.isAfter)((0, date_fns_1.parseISO)(dataFim !== null && dataFim !== void 0 ? dataFim : ''), (0, date_fns_1.parseISO)(dataIni)) || (0, date_fns_1.isEqual)((0, date_fns_1.parseISO)(dataFim !== null && dataFim !== void 0 ? dataFim : ''), (0, date_fns_1.parseISO)(dataIni)))
        .default((0, date_fns_1.format)(new Date(), 'yyyy-MM-dd'))
        .label('Data final'),
    motivo: yup.string().required().label('Motivo do atestado').max(100, 'Máximo de 100 caracteres.'),
    idAluno: yup.number().integer().positive().required().label('Aluno'),
});
exports.schemaAtestado = exports.yupAtestado.shape({});
